import $ from 'jquery';
/* ===============================================================
Navbar full screen
=============================================================== */
class NavbarFullScreen {
    constructor() {
        // Singleton pattern - return existing instance if it exists
        if (NavbarFullScreen.instance) {
            return NavbarFullScreen.instance;
        }

        this.btnOpen = $('.irantheme-navbar-trigger');
        this.btnClose = $('.irantheme-navbar-full-screen-close');
        this.fullScreen = $('.irantheme-navbar-full-screen');
        this.fullScreenHolder = $('.irantheme-navbar-full-screen-holder');

        // Cache DOM elements
        this.menuOptionsLis = this.fullScreen.find(
            '.irantheme-navbar-full-screen-options-ul > li',
        );
        this.menuParentsLink = this.fullScreen.find(
            '.irantheme-navbar-full-screen-menu-ul .menu-item-has-children > a',
        );
        this.menuFirstLis = this.fullScreen.find(
            '.irantheme-navbar-full-screen-menu-ul > li',
        );
        this.socialMediaItems = this.fullScreen.find(
            '.irantheme-social-media > li',
        );

        // Cache window and admin bar
        this.$window = $(window);
        this.$adminBar = $('#wpadminbar');
        this.$inputElements = $('input, textarea');

        this.isOpen = false;

        // Early return if no elements exist
        if (!this.btnOpen.length || !this.fullScreen.length) return;

        this.events();
    }

    events() {
        // Open handler with event delegation check
        this.btnOpen.on('click', (e) => {
            e.preventDefault();
            if (this.isTriggerDesktop() || this.isTriggerMobile()) {
                this.openFullScreen();
            }
        });

        // Close handler
        this.btnClose.on('click', (e) => {
            e.preventDefault();
            this.closeFullScreen();
        });

        // Keyboard navigation
        $(document).on('keydown', (e) => {
            if (this.isTriggerDesktop() || this.isTriggerMobile()) {
                this.handleKeyPress(e);
            }
        });

        // Event binding with more specific selector
        this.fullScreen.on(
            'click',
            '.irantheme-navbar-full-screen-menu-ul .menu-item-has-children > a.menu-item-link',
            (e) => {
                e.preventDefault();
                this.toggleMenu(e);
            },
        );
    }

    openFullScreen() {
        if (this.isOpen) return;

        this.fullScreenHolder.show();
        this.open();
        this.animationEffects();

        // Set close button position
        const adminBarHeight = this.$adminBar.length
            ? this.$adminBar.height()
            : 0;
        this.btnClose.css('top', adminBarHeight);
    }

    closeFullScreen() {
        if (!this.isOpen) return;

        this.fullScreenHolder.fadeOut(500, () => {
            this.close();
        });
    }

    toggle() {
        this.btnOpen.toggleClass('active');
        this.fullScreen.stop(true, true).fadeToggle(600);
        this.isOpen = !this.isOpen;
    }

    open() {
        this.btnOpen.addClass('active');
        this.fullScreen.stop(true, true).fadeIn(600);
        this.isOpen = true;
    }

    close() {
        this.btnOpen.removeClass('active');
        this.fullScreen.stop(true, true).fadeOut(250, () => {
            // Cleanup after animation completes
            this.menuParentsLink.removeClass('active');
            this.menuParentsLink.siblings('.sub-menu').slideUp(250);
        });
        this.isOpen = false;
    }

    handleKeyPress(e) {
        // Early return if input is focused
        if (this.$inputElements.is(':focus')) return;

        const key = e.keyCode || e.which;

        switch (key) {
            case 77: // 'M' key
                if (
                    !this.isOpen &&
                    (this.isTriggerDesktop() || this.isTriggerMobile())
                ) {
                    this.openFullScreen();
                }
                break;
            case 27: // Escape key
                if (this.isOpen) {
                    this.closeFullScreen();
                }
                break;
        }
    }

    toggleMenu(e) {
        // Robust target detection with multiple fallbacks
        let $target;

        // Try multiple methods to get the correct link element
        const $clickedElement = $(e.target);

        // Method 1: Direct click on link
        if (
            $clickedElement.hasClass('menu-item-link') ||
            $clickedElement.is('a')
        ) {
            $target = $clickedElement;
        }
        // Method 2: Click inside link
        else if ($clickedElement.closest('.menu-item-link').length) {
            $target = $clickedElement.closest('.menu-item-link');
        }
        // Method 3: Event delegation fallback
        else {
            $target = $(e.currentTarget);
        }

        // Validate we have a proper link element
        if (!$target.length || !$target.is('a.menu-item-link')) {
            return;
        }

        // Get parent li and its siblings at the same level
        const $parentLi = $target.closest('li.menu-item-has-children');
        const $siblings = $parentLi.siblings('li.menu-item-has-children');

        if ($target.hasClass('active')) {
            // Close current menu
            $target.removeClass('active');
            $target.siblings('.sub-menu').stop(true, true).slideUp(250);
        } else {
            // Close sibling menus first
            this.closeSiblingMenus($target, $siblings);

            // Open current menu
            $target.addClass('active');
            $target.siblings('.sub-menu').stop(true, true).slideDown(250);
        }

        // Prevent event bubbling
        e.stopImmediatePropagation();
    }

    closeSiblingMenus($current, $siblings) {
        // Check if there are any active menus at all
        const hasAnyActive =
            this.fullScreen.find('.menu-item-link.active').length > 0;

        if (!hasAnyActive) {
            // Close all menus
            this.menuParentsLink.removeClass('active');
            this.menuParentsLink
                .siblings('.sub-menu')
                .stop(true, true)
                .slideUp(250);
        } else {
            // Close only sibling menus
            $siblings.each((index, sibling) => {
                const $siblingLink = $(sibling).children('.menu-item-link');
                const $siblingSubMenu = $(sibling).children('.sub-menu');

                if ($siblingLink.hasClass('active')) {
                    $siblingLink.removeClass('active');
                    $siblingSubMenu.stop(true, true).slideUp(250);
                }
            });
        }
    }

    animationEffects() {
        // Use requestAnimationFrame for smoother animations
        requestAnimationFrame(() => {
            // Apply animations with proper sequencing
            this.applyAnimationDelay(this.menuOptionsLis, 200);
            this.applyAnimationDelay(this.menuFirstLis, 200);
            this.applyAnimationDelay(this.socialMediaItems, 200);
        });
    }

    applyAnimationDelay($elements, baseDelay) {
        $elements.each((index, element) => {
            $(element).css('animation-delay', `${(index + 1) * baseDelay}ms`);
        });
    }

    isTriggerDesktop() {
        const desktopTriggerMode = this.btnOpen
            .parent()
            .data('trigger-desktop');
        const windowWidth = this.$window.outerWidth();

        return desktopTriggerMode === 'fullscreen' && windowWidth >= 1200;
    }

    isTriggerMobile() {
        const mobileTriggerMode = this.btnOpen.parent().data('trigger-mobile');
        const windowWidth = this.$window.outerWidth();

        return mobileTriggerMode === 'fullscreen' && windowWidth < 1200;
    }
}

export default NavbarFullScreen;
